import Link from 'next/link'
import Image from 'next/image'
import NavUtility from './NavUtility'
import NavPrimary from './NavPrimary'
import NavMobile from './NavMobile'

const Logo = () => {
    return (
        <>
            <div className='logo'><Link href='/'><a><Image width='301' height='207' src='/images/logos/bandr.png' alt='Autowrecking.com. Powered by B&R.' /></a></Link></div>
            <style jsx>
                {`
                    @import '@css/variables.css';

                    .logo {
                        position: absolute;
                        top: var(--headerLogoOffsetTop);
                        left: var(--headerLogoOffsetLeft);
                        z-index: 2;

                        :global(img) {
                            width: var(--headerLogoWidth);
                            height: var(--headerLogoHeight);
                            max-width: 350px; /* for IE11 */
                        }
                    }
                `}
            </style>
        </>
    )
}

export default function Header() {
    return (
        <>
            <header>
                <Logo />
                <NavUtility />
                <NavPrimary />
                <NavMobile />
            </header>
            <style jsx>
                {`
                    @import '@css/variables.css';

                    header {
                        --headerLogoWidth: 164px;
                        --headerLogoHeight: 113px;
                        --headerLogoOffsetTop: 17px;
                        --headerLogoOffsetLeft: 30px;
                        --headerLogoPaddingLeft: 30px;

                        position: relative;

                        @media(--header-mobile) {
                            --headerLogoOffsetLeft: 15px;
                            --headerLogoPaddingLeft: 15px;
                        }

                        @media(--xxs) {
                            --headerLogoWidth: 120px;
                            --headerLogoHeight: 83px;
                        }

                        @media(max-width: 421px) {
                            --headerLogoWidth: 98px;
                            --headerLogoHeight: 68px;
                        }

                        @media(max-width: 370px) {
                            --headerLogoWidth: 87px;
                            --headerLogoHeight: 60px;
                        }

                        @media(max-width: 354px) {
                            --headerLogoOffsetLeft: 10px;
                            --headerLogoPaddingLeft: 10px;
                        }
                    }
                `}
            </style>
        </>
    )
}
